export const xinC = [
  [
    [113.68062545945926, 23.01353404521013, 10],
    [113.68061085646922, 23.01352206911439, 10],
  ],
  [
    [113.68056077041942, 23.013601632728815, 10],
    [113.68054616742783, 23.013589656627197, 10],
  ],
  [
    [113.68049608130647, 23.013669220319585, 10],
    [113.68048147833049, 23.013657244194185, 10],
  ],
  [
    [113.68043139214625, 23.013736807774986, 10],
    [113.6804167891516, 23.013724831661623, 10],
  ],
  [
    [113.6803667030105, 23.013804395212205, 10],
    [113.68035210001433, 23.013792419092983, 10],
  ],
  [
    [113.68030201371275, 23.013871982622213, 10],
    [113.68028741071502, 23.013860006497133, 10],
  ],
  [
    [113.68023732434187, 23.013939570104327, 10],
    [113.6802227213598, 23.01392759395546, 10],
  ],
  [
    [113.68017263491515, 23.014007157460007, 10],
    [113.68015803193154, 23.013995181305276, 10],
  ],
  [
    [113.68010794543252, 23.014074744779577, 10],
    [113.68009334243024, 23.014062768636876, 10],
  ],
  [
    [113.68004326840287, 23.014142324191617, 10],
    [113.68002864600255, 23.014130368339067, 10],
  ],
  [
    [113.67997878355862, 23.014210032667208, 10],
    [113.67996411160635, 23.01419812893711, 10],
  ],
  [
    [113.67991458046359, 23.014277970032754, 10],
    [113.67989985912797, 23.014266118652277, 10],
  ],
  [
    [113.67985066004074, 23.014346135622873, 10],
    [113.67983588959636, 23.014334336706703, 10],
  ],
  [
    [113.67978702331777, 23.014414528119257, 10],
    [113.67977220393634, 23.014402781891903, 10],
  ],
  [
    [113.67972367113994, 23.01448314665532, 10],
    [113.67970880305971, 23.014471453269948, 10],
  ],
  [
    [113.67966060448211, 23.01455199033041, 10],
    [113.67964568794375, 23.014540349937068, 10],
  ],
  [
    [113.67959782425834, 23.014621057842223, 10],
    [113.67958285943185, 23.014609470668677, 10],
  ],
  [
    [113.6795353314892, 23.01469034843738, 10],
    [113.67952031865063, 23.014678814594397, 10],
  ],
  [
    [113.67947312690481, 23.014759860981354, 10],
    [113.67945806623709, 23.014748380682903, 10],
  ],
  [
    [113.6794112116538, 23.01482959432627, 10],
    [113.67939610338526, 23.014818167736017, 10],
  ],
  [
    [113.6793495865032, 23.014899547676137, 10],
    [113.67933443089005, 23.014888174925737, 10],
  ],
  [
    [113.67928825235872, 23.01496971991744, 10],
    [113.67927304960311, 23.014958401199863, 10],
  ],
  [
    [113.67922721019467, 23.015040109878992, 10],
    [113.67921196050263, 23.015028845383377, 10],
  ],
  [
    [113.67916646086492, 23.01511071668721, 10],
    [113.67915116449191, 23.01509950654534, 10],
  ],
  [
    [113.67910600537785, 23.015181539131554, 10],
    [113.67909066251514, 23.015170383550107, 10],
  ],
  [
    [113.67904584448253, 23.015252576347216, 10],
    [113.67903045538532, 23.015241475457863, 10],
  ],
  [
    [113.67898597917221, 23.015323827231406, 10],
    [113.67897054406171, 23.015312781205775, 10],
  ],
  [
    [113.67892641031405, 23.0153952906249, 10],
    [113.67891092943468, 23.015384299606776, 10],
  ],
  [
    [113.67886713515959, 23.01546696991664, 10],
    [113.67885161581478, 23.01545602546733, 10],
  ],
  [
    [113.67880801971785, 23.015538798470907, 10],
    [113.67879249984476, 23.015527854653634, 10],
  ],
  [
    [113.67874890560873, 23.015610628586078, 10],
    [113.67873338573222, 23.015599684763107, 10],
  ],
  [
    [113.67868979143694, 23.015682458678366, 10],
    [113.67867427155701, 23.015671514849686, 10],
  ],
  [
    [113.67863067729068, 23.01575428866895, 10],
    [113.67861515742618, 23.015743344811707, 10],
  ],
  [
    [113.67857156299361, 23.01582611871548, 10],
    [113.67855604312568, 23.015815174852527, 10],
  ],
  [
    [113.67851244864327, 23.015897948727684, 10],
    [113.6784969287531, 23.015887004881904, 10],
  ],
  [
    [113.67845333422092, 23.01596977863815, 10],
    [113.67843781432734, 23.015958834786662, 10],
  ],
  [
    [113.67839421982403, 23.01604160862751, 10],
    [113.67837869994585, 23.016030664747447, 10],
  ],
  [
    [113.67833510527632, 23.016113438582508, 10],
    [113.67831958539472, 23.016102494696735, 10],
  ],
  [
    [113.67827599067542, 23.01618526841289, 10],
    [113.67826047077159, 23.016174324544274, 10],
  ],
  [
    [113.6782168760024, 23.01625709832211, 10],
    [113.67820135609517, 23.016246154447803, 10],
  ],
  [
    [113.67815776125958, 23.016328928217167, 10],
    [113.67814224136325, 23.016317984319738, 10],
  ],
  [
    [113.6780986465566, 23.016400757993104, 10],
    [113.67808312666136, 23.01638981408451, 10],
  ],
  [
    [113.67803953169563, 23.016472587833672, 10],
    [113.67802401179696, 23.01646164391938, 10],
  ],
  [
    [113.67798041677425, 23.01654441764864, 10],
    [113.67796489686766, 23.0165334737341, 10],
  ],
  [
    [113.67792130179515, 23.016616247344448, 10],
    [113.67790578187085, 23.016605303441604, 10],
  ],
  [
    [113.67786218674621, 23.016688077116367, 10],
    [113.67784666681848, 23.016677133207825, 10],
  ],
  [
    [113.67780307171559, 23.016759906885582, 10],
    [113.67778755181757, 23.01674896293107, 10],
  ],
  [
    [113.67774395654854, 23.016831736512742, 10],
    [113.67772843663279, 23.01682079256992, 10],
  ],
  [
    [113.67768484132102, 23.01690356620457, 10],
    [113.67766932138305, 23.016892622278913, 10],
  ],
];
